import React from 'react';
import { motion } from 'framer-motion';
import ProjectCard from '../components/ProjectCard';

const FEATURED = [
  { prjLink: 'https://kundli.online', imgURL: 'kundli-online.png', title: 'Kundli Online', desc: 'Vedic astrology platform for generating birth charts and horoscope insights. Real-time Kundli generation with detailed planetary positions.', stat: '100k+ impressions' },
  { prjLink: 'https://chromewebstore.google.com/detail/nimbus-ai/khpccmnjmjjmgdaiiebjhopfcalhnpgi', imgURL: 'nimbus-ai.png', title: 'Nimbus AI', desc: 'Chrome extension for live AI agent browsing — automates and assists tasks directly in your browser using real-time AI.' },
];

const GRID = [
  { prjLink: 'https://precision-fuel.vercel.app/', imgURL: 'precision-fuel.png', title: 'Precision Fuel', desc: 'Clean nutrition tracker for logging meals, macros, and daily intake.' },
  { prjLink: 'https://mybeauty-livid.vercel.app/', imgURL: 'beauty-flow.png', title: 'Beauty Flow', desc: 'AI facial analysis app — personalised skin, makeup & hairstyle recs in under 2s.' },
  { prjLink: '#', imgURL: 'project-7.png', title: 'Ringer JS', desc: 'Opinionated toast component for Vanilla JS.', isUpcoming: true },
  { prjLink: 'https://drag-my-stuff.vercel.app/', imgURL: 'project-1.png', title: 'Drag My Stuff', desc: 'Drag and drop selected items onto any webpage.', isBeta: true },
  { prjLink: 'https://www.npmjs.com/package/curl-to-json-convert', imgURL: 'project-6.png', title: 'curl-to-json', desc: 'Converts cURL commands to JSON for frontend use. No backend needed.' },
  { prjLink: 'https://github.com/HARSHSINGH0/WonderCook/', imgURL: 'project-2.png', title: 'WonderCook', desc: 'Recipe suggestions based on ingredients you already have.' },
  { prjLink: 'https://confusedbond.itch.io/dumb', imgURL: 'project-3.jpg', title: 'Dumb Game', desc: '2D platformer where the developer is your enemy.' },
  { prjLink: 'https://github.com/HARSHSINGH0/eyemousecontroller/releases/tag/eyemousecontroller', imgURL: 'project-3.png', title: 'Eye Mouse Controller', desc: 'Control the cursor with your eyes — built for accessibility.' },
];

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55 } },
};

const Projects = () => (
  <section id="projects" className="section">
    <div className="section-inner">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-80px' }}
        variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
      >
        <motion.p className="section-label" variants={fadeUp}>Work</motion.p>
        <motion.h2 className="section-title" variants={fadeUp}>Projects</motion.h2>

        {/* Featured row */}
        <motion.div className="bento-featured-row" variants={fadeUp}>
          {FEATURED.map(p => (
            <ProjectCard key={p.title} {...p} featured />
          ))}
        </motion.div>

        {/* Standard grid */}
        <div className="projects-grid">
          {GRID.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.06 }}
            >
              <ProjectCard {...p} />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);

export default Projects;
